import React from 'react';

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-black fixed-top" data-aos="fade-down">
      <div className="container">
        <a className="navbar-brand fs-3 fw-bold" href="#">S.STATE</a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto align-items-center">
            <li className="nav-item"><a className="nav-link" href="#about">من نحن</a></li>
            <li className="nav-item"><a className="nav-link" href="#services">خدماتنا</a></li>
            <li className="nav-item"><a className="nav-link" href="#portfolio">أعمالنا</a></li>
            <li className="nav-item"><a className="nav-link" href="#contact">اتصل بنا</a></li>
            <li className="nav-item">
              <a className="btn btn-danger text-black px-4 py-2 rounded-pill fw-bold ms-3" href="#contact">
                انضم إلينا
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;